// OFFICEWORKER — 22 tools in 4 blocks. Numbers 5, 6, 8, 9, 10 and 11 of the earlier list do not
// exist on the card; old 14 (Hex 3/8" 5/16" 1/4") and 18 (Open wrench 6 7 8) were absorbed by the
// redefined 13/16/17 and dropped — restore them if they turn out to be separate cutouts.
// Positions are card millimetres (mx from the face's left edge, my from its top); est:true = a parked
// guess on a placement grid, replaced the moment a mark is placed. Face A = metric side, B = imperial.
// hom: photo% -> card fraction. Both faces fitted in two stages (silhouette-with-holes, then the real
// engraving): A 0.94 / 0.88, B 0.97 / 0.87 — both photos are usable for placement.
// 6/7/8 mm are CLOSED nut cutouts, not open jaws. Numbering 1–22 → marks live in the ow_marks_v3
// store (see MSTORE in the hub).
window.OW = {
 "hom": {
  "A": [[0.01118972, 0.00097845, -0.07642622], [-0.00000376, 0.01480741, -0.16712406], [0.00002821, 0.00097159, 1]],
  "B": [[0.01226483, 0.0035814, -0.22753901], [-0.00401536, 0.0204418, -0.23033302], [0.00025875, 0.00260438, 1]]
 },
 "photo": {
  "A": "https://mrf.tools/cdn/shop/files/mrf26-ow-photo-a.jpg?v=b3",
  "B": "https://mrf.tools/cdn/shop/files/mrf26-ow-photo-b.jpg?v=b3"
 },
 "blocks": [
  {
   "id": "measure",
   "label": "Measure & draw",
   "sub": "Rulers, angles, circles",
   "tools": [
    {
     "n": 1,
     "cat": "MEASURE",
     "side": "A",
     "mx": 51.1,
     "my": 0,
     "est": false,
     "name": "Metric ruler",
     "desc": "70 mm along the top edge, millimetre ticks cut through the edge so you read against the work instead of beside it.",
     "sc": "Sizing a package before the courier form asks for it."
    },
    {
     "n": 2,
     "cat": "MEASURE",
     "side": "B",
     "mx": 47.9,
     "my": 0,
     "est": false,
     "name": "Inch ruler",
     "desc": "2½\" scale on the back edge in halves, quarters and eighths.",
     "sc": "Reading an imperial drawing that came in from a US supplier."
    },
    {
     "n": 3,
     "cat": "MEASURE",
     "side": "A",
     "mx": 0,
     "my": 27.2,
     "est": false,
     "name": "Side ruler",
     "desc": "40 mm down the short edge — the one that fits inside a drawer or a shipping box.",
     "sc": "Measuring a shelf gap without unfolding anything."
    },
    {
     "n": 4,
     "cat": "ANGLE",
     "side": "A",
     "mx": 42.5,
     "my": 27.5,
     "est": false,
     "name": "Protractor 360°",
     "desc": "A full circle, not a half: the ring runs 0° to 330° in 10° steps with 1° ticks, centred on the pivot hole.",
     "sc": "Checking a rotation on a printed layout."
    },
    {
     "n": 5,
     "cat": "DRAW",
     "side": "B",
     "mx": 85,
     "my": 39,
     "est": false,
     "name": "Compass",
     "desc": "The pivot hole plus the radius holes down the arc: pin the pivot, put a pencil in a hole and swing a true circle.",
     "sc": "Striking a clean arc with no compass in the bag."
    },
    {
     "cat": "MEASURE",
     "side": "A",
     "name": "Metric L-square",
     "desc": "Square corner with a millimetre scale on both legs.",
     "sc": "Squaring a cut on foam board at the desk.",
     "mx": 0,
     "my": 0,
     "n": 6,
     "est": false
    },
    {
     "cat": "MEASURE",
     "side": "B",
     "name": "Inch L-square",
     "desc": "The same corner in inches, on the imperial face.",
     "sc": "Marking a 2\" border on a mount board.",
     "mx": 85,
     "my": 0,
     "n": 7,
     "est": false
    }
   ]
  },
  {
   "id": "drive",
   "label": "Nuts & drivers",
   "sub": "Hex, bits, open wrenches",
   "tools": [
    {
     "n": 8,
     "cat": "WRENCH",
     "side": "A",
     "mx": 9.6,
     "my": 12.7,
     "est": false,
     "name": "Hex nuts 10 mm, 3/8\", 5/16\"",
     "desc": "Three nut cutouts in one step — 10 mm with its imperial neighbours 3/8\" and 5/16\".",
     "sc": "A wobbling monitor arm bolt, tightened without leaving the desk."
    },
    {
     "n": 9,
     "cat": "DRIVE",
     "side": "A",
     "mx": 8.4,
     "my": 30.1,
     "est": false,
     "name": "1/4\" bit driver",
     "desc": "Holder for standard 1/4\" hex bits, so the card becomes the handle.",
     "sc": "Driving the screw on a desk clamp with a bit from the drawer."
    },
    {
     "n": 10,
     "cat": "WRENCH",
     "side": "A",
     "mx": 14.1,
     "my": 39,
     "est": false,
     "name": "Hex 6, 5.5, 3/16\", 4, 3 mm",
     "desc": "The fine run of hex sizes for furniture, bike and electronics hardware.",
     "sc": "An M4 hex on a chair base that keeps working loose."
    },
    {
     "n": 11,
     "cat": "WRENCH",
     "side": "A",
     "mx": 75.5,
     "my": 35.6,
     "est": false,
     "name": "Hex nuts 6, 7, 8 mm",
     "desc": "Closed cutouts for the three small metric nuts — they hold a rounded nut an open jaw would slip off.",
     "sc": "A 7 mm nut on a lamp arm that has been turned once too often."
    },
    {
     "n": 12,
     "cat": "DRIVE",
     "side": "A",
     "mx": 80.3,
     "my": 0,
     "est": false,
     "name": "Phillips screwdriver",
     "desc": "Ground cross tip at the corner: the card becomes the handle, so it drives with real leverage.",
     "sc": "Swapping a plug fuse or a keyboard foot."
    },
    {
     "cat": "WRENCH",
     "side": "A",
     "name": "O₂ gas wrench",
     "desc": "Cutout for oxygen bottle and regulator fittings.",
     "sc": "Opening an O₂ regulator without the proper spanner.",
     "mx": 71.3,
     "my": 38.6,
     "n": 13,
     "est": false
    }
   ]
  },
  {
   "id": "open",
   "label": "Open & cut",
   "sub": "Parcels, cord, cans, bottles",
   "tools": [
    {
     "n": 14,
     "cat": "CUT",
     "side": "A",
     "mx": 78.4,
     "my": 54.8,
     "est": false,
     "name": "Box opener",
     "desc": "Hooked corner notch that catches packing tape and cuts it as you pull — no blade near the contents, and none for security either.",
     "sc": "Opening the day's parcels at the studio door."
    },
    {
     "n": 15,
     "cat": "CUT",
     "side": "A",
     "mx": 65.3,
     "my": 48,
     "est": false,
     "name": "Cord cutter",
     "desc": "Hooked slot that catches string or cable tie and shears it as you pull.",
     "sc": "Cutting the tie off a new cable run."
    },
    {
     "n": 16,
     "cat": "CAMP",
     "side": "A",
     "mx": 83.5,
     "my": 54.2,
     "est": false,
     "name": "Can opener",
     "desc": "Stepped hook that walks a tin lid open — slow, but it always works.",
     "sc": "Lunch on a day nobody left the building."
    },
    {
     "n": 17,
     "cat": "CAMP",
     "side": "A",
     "mx": 68.6,
     "my": 55,
     "est": false,
     "name": "Bottle opener",
     "desc": "Marked cap lifter, sized so the card doesn't twist in your fingers.",
     "sc": "The end of a long release week."
    }
   ]
  },
  {
   "id": "desk",
   "label": "Desk fixes",
   "sub": "Holes, edges, levers",
   "tools": [
    {
     "n": 18,
     "cat": "DRILL",
     "side": "B",
     "mx": 8.2,
     "my": 24.3,
     "est": false,
     "name": "Metric drill guide",
     "desc": "Graded hole arc across the top right: drop a bit in until it stops and you have its diameter without a caliper.",
     "sc": "Finding the right bit in a drawer of unmarked ones."
    },
    {
     "n": 19,
     "cat": "CUT",
     "side": "A",
     "mx": 0,
     "my": 32.8,
     "est": false,
     "name": "Scraper",
     "desc": "Blunt ground edge in the left cut-out for scraping — label residue, dried glue, a sticker on a laptop lid.",
     "sc": "Getting an asset tag off a returned machine."
    },
    {
     "n": 20,
     "cat": "BUILD",
     "side": "A",
     "mx": 0,
     "my": 55,
     "est": false,
     "name": "Nail puller",
     "desc": "The V-notch at the bottom-left corner grips a nail head or a staple and levers it out.",
     "sc": "Pulling staples out of a crate lid."
    },
    {
     "cat": "PRY",
     "side": "A",
     "name": "Pry bar",
     "desc": "Thick lever end for lids, staples and stuck drawers.",
     "sc": "Levering a jammed drawer front without marking it.",
     "mx": 85,
     "my": 53.6,
     "n": 21,
     "est": false
    },
    {
     "cat": "FIELD",
     "side": "B",
     "name": "Wire bender holes",
     "desc": "Holes in graded diameters — feed the wire in and bend it to a clean, repeatable angle.",
     "sc": "Bending a wire hook to hang a cable behind the desk.",
     "mx": 0,
     "my": 19.7,
     "n": 22,
     "est": false
    }
   ]
  }
 ]
};
